<template>
  <table class="table" style="padding-top: 10px;">
    <tr>
      <td style="width: 650px;">
        <table class="table" style=" width: 100%">
          <tr>
            <td style="width: 164px; height: 60px;" class="ico ico-home">
              <img src="@/../public/img/ot_logo3.jpg" width="150" height="59"></td>
            <td>
              <h2 style="font-size:21px; text-align: center;">
                서비스 내역서(본사용)
              </h2>
            </td>
            <td style="width: 100px;"></td>
          </tr>
        </table>
      </td>
    </tr>
    <tr>
      <td>
        <table width="650" border="1" cellpadding="0" cellspacing="0" bordercolor="#333333" bgcolor="#333333" class="font-big" style="table-layout:fixed">
          <tr style="background-color: white;">
            <td style="width: 88px; height: 20px;">접수번호</td>
            <td style="width: 127px;">{{asRepair.asId}}-{{idx + 1}}</td>
            <td style="width: 70px;">접수일시</td>
            <td style="width: 123px;">{{asRepair.callDt}}</td>
            <td style="width: 88px;">고객명</td>
            <td style="width: 134px;">{{asRepair.boundCustNm}}</td>
          </tr>
          <tr style="background-color: white;">
            <td height="20">사이트명</td>
            <td colspan="5">{{asRepair.siteNm}}</td>
          </tr>
          <tr style="background-color: white;">
            <td height="20">주소</td>
            <td colspan="5">{{asRepair.addr}}</td>
          </tr>
          <tr style="background-color: white;">
            <td height="20">연락처</td>
            <td colspan="2">{{asRepair.telNo}}</td>
            <td>핸드폰</td>
            <td colspan="2">{{asRepair.hpNo}}</td>
          </tr>
          <tr style="background-color: white;">
            <td height="20">모델명</td>
            <td colspan="2">{{asRepair.modelNm}}</td>
            <td>제조번호</td>
            <td colspan="2">{{asRepair.serialNo}}</td>
          </tr>
          <tr style="background-color: white;">
            <td height="20">구입년월</td>
            <td colspan="2">{{asRepair.purchaseDt}}</td>
            <td>제조년월</td>
            <td colspan="2">{{asRepair.prodDt }}</td>
          </tr>
          <tr style="background-color: white;">
            <td height="20">고장증상</td>
            <td colspan="2">{{asRepair.asRepairCatNm4 }}</td>
            <td>고장부위</td>
            <td colspan="2">{{asRepair.asRepairCatNm5 }}</td>
          </tr>
          <tr style="background-color: white;">
            <td height="20">고장원인</td>
            <td colspan="2">{{asRepair.asFailureCauseCatNm }}</td>
            <td>처리유형</td>
            <td colspan="2">{{asRepair.changeAsClassCdNm }}</td>
          </tr>
          <tr style="background-color: white;">
            <td height="20">상세내역</td>
            <td colspan="5">{{asRepair.changeAsClassMemo }}</td>
          </tr>
          <tr style="background-color: white;">
            <td height="20">처리일시</td>
            <td colspan="2">{{asRepair.procDt  }}</td>
            <td>유.무상</td>
            <td colspan="2">{{asRepair.changePayYnCd  }}</td>
          </tr>
          <tr style="background-color: white;">
            <td height="20">처리센터</td>
            <td colspan="2">{{asRepair.repairAsAgentNm  }}</td>
            <td>처리기사</td>
            <td colspan="2">{{asRepair.repairNm  }}</td>
          </tr>
          <tr style="background-color: white;">
            <td height="20">기술료</td>
            <td>{{asRepair.asRepairAmt  }}</td>
            <td>자재비</td>
            <td>{{asRepair.asRepairItemAmt  }}</td>
            <td>실청구금액</td>
            <td>{{asRepair.asRepairFeeAmtReal  }}</td>
          </tr>
          <tr style="background-color: white;">
            <td height="10" colspan="6"></td>
          </tr>
          <tr style="background-color: white;">
            <td style="height: 20px; font-size: 14px;">자재사용내역</td>
            <td colspan="5">
              <table>
                <tr style="background-color: #FFFFFF; ">
                  <td style="width: 9%; text-align: center;">순번</td>
                  <td style="width: 16%; text-align: center;">품번</td>
                  <td style="width: 18%; text-align: center;">품명</td>
                  <td style="width: 18%; text-align: center;">규격</td>
                  <td style="width: 8%; text-align: center;">수량</td>
                  <td style="width: 16%; text-align: center;">단가</td>
                  <td style="width: 15%; text-align: center;">금액</td>
                </tr>
              </table>
              <table v-if = "asItem.length == 0">
                <tr bgcolor="#FFFFFF" v-for="i in 3">
                  <td style="width: 9%; height: 20px; overflow:hidden; text-align: center;"><nobr>{{i}}</nobr></td>
                  <td style="width: 16%; height: 20px; overflow:hidden; text-align: center;"><nobr></nobr></td>
                  <td style="width: 18%; overflow:hidden; text-align: center;"><nobr></nobr></td>
                  <td style="width: 18%; overflow:hidden; text-align: center;"><nobr></nobr></td>
                  <td style="width: 8%; overflow:hidden; text-align: center;"><nobr></nobr></td>
                  <td style="width: 16%; overflow:hidden; text-align: center;"><nobr></nobr></td>
                  <td style="width: 15%; overflow:hidden; text-align: center;"><nobr></nobr></td>
                </tr>
              </table>
              <table v-else>
                <tr bgcolor="#FFFFFF" v-for="(item, i) in asItem" :key="i">
                  <td style="width: 9%; height: 20px; overflow:hidden; text-align: center;"><nobr>{{item.asProcessId}}</nobr></td>
                  <td style="width: 16%; height: 20px; overflow:hidden; text-align: center;"><nobr>{{item.itemCd}}</nobr></td>
                  <td style="width: 18%; overflow:hidden; text-align: center;"><nobr>{{item.itemNm}}</nobr></td>
                  <td style="width: 18%; overflow:hidden; text-align: center;"><nobr>{{item.itemSpec}}</nobr></td>
                  <td style="width: 8%; overflow:hidden; text-align: center;"><nobr>{{item.itemQty}}</nobr></td>
                  <td style="width: 16%; overflow:hidden; text-align: center;"><nobr>{{item.unitPrice1}}</nobr></td>
                  <td style="width: 15%; overflow:hidden; text-align: center;"><nobr>{{item.unitPrice3}}</nobr></td>
                </tr>
              </table>
            </td>
          </tr>
          <tr bgcolor="white">
            <td height="40">특이사항</td>
            <td colspan="5" class="font12_red">&nbsp;{{ asRepair.asDescription }}</td>
          </tr>
        </table>
      </td>
    </tr>
    <tr>
      <td>&nbsp;</td>
    </tr>
    <tr>
      <td>
        <table width="100%" border="0" cellspacing="0" cellpadding="0">
          <tr>
            <td width="47%">&nbsp;</td>
            <td width="23%" class="font-big">상기내용을 확인합니다. </td>
            <td width="30%">
              <table width="100%" border="1" cellpadding="0" cellspacing="0" bordercolor="#000000" class="font-big">
                <tr>
                  <td height="37">
                    &nbsp;<br />
                    고객확인 :
                    <br />&nbsp;
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </td>
    </tr>
    <tr>
      <td style="height: 60px;" height="45">&nbsp;</td>
    </tr>
    <tr>
      <td>
        <hr style="border: dashed 2px #666666"/>
      </td>
    </tr>
    <tr>
      <td>&nbsp;</td>
    </tr>
    <tr>
      <td style="width: 650px;">
        <table style="width: 100%">
          <tr>
            <td style="width: 164px; height: 60px;" class="ico ico-home">
              <img src="@/../public/img/ot_logo3.jpg" width="150" height="59"></td>
            <td>
              <h2 style="font-size:21px; text-align: center;">
                서비스 내역서(고객용)
              </h2>
            </td>
            <td width="100px"></td>
          </tr>
        </table>
      </td>
    </tr>
    <tr>
      <td>
        <table width="650" border="1" cellpadding="0" cellspacing="0" bordercolor="#333333" bgcolor="#333333" class="font-big" style="table-layout:fixed">
          <tr style="background-color: white;">
            <td style="width: 88px; height: 20px;">접수번호</td>
            <td style="width: 127px;">{{asRepair.asId}}-{{idx + 1}}</td>
            <td style="width: 70px;">접수일시</td>
            <td style="width: 123px;">{{asRepair.callDt}}</td>
            <td style="width: 88px;">고객명</td>
            <td style="width: 134px;">{{asRepair.boundCustNm}}</td>
          </tr>
          <tr style="background-color: white;">
            <td height="20">사이트명</td>
            <td colspan="5">{{asRepair.siteNm}}</td>
          </tr>
          <tr style="background-color: white;">
            <td height="20">주소</td>
            <td colspan="5">{{asRepair.addr}}</td>
          </tr>
          <tr style="background-color: white;">
            <td height="20">연락처</td>
            <td colspan="2">{{asRepair.telNo}}</td>
            <td>핸드폰</td>
            <td colspan="2">{{asRepair.hpNo}}</td>
          </tr>
          <tr style="background-color: white;">
            <td height="20">모델명</td>
            <td colspan="2">{{asRepair.modelNm}}</td>
            <td>제조번호</td>
            <td colspan="2">{{asRepair.serialNo}}</td>
          </tr>
          <tr style="background-color: white;">
            <td height="20">구입년월</td>
            <td colspan="2">{{asRepair.purchaseDt}}</td>
            <td>제조년월</td>
            <td colspan="2">{{asRepair.prodDt }}</td>
          </tr>
          <tr style="background-color: white;">
            <td height="20">고장증상</td>
            <td colspan="2">{{asRepair.asRepairCatNm4 }}</td>
            <td>고장부위</td>
            <td colspan="2">{{asRepair.asRepairCatNm5 }}</td>
          </tr>
          <tr style="background-color: white;">
            <td height="20">고장원인</td>
            <td colspan="2">{{asRepair.asFailureCauseCatNm }}</td>
            <td>처리유형</td>
            <td colspan="2">{{asRepair.changeAsClassCdNm }}</td>
          </tr>
          <tr style="background-color: white;">
            <td height="20">상세내역</td>
            <td colspan="5">{{asRepair.changeAsClassMemo }}</td>
          </tr>
          <tr style="background-color: white;">
            <td height="20">처리일시</td>
            <td colspan="2">{{asRepair.procDt  }}</td>
            <td>유.무상</td>
            <td colspan="2">{{asRepair.changePayYnCd  }}</td>
          </tr>
          <tr style="background-color: white;">
            <td height="20">처리센터</td>
            <td colspan="2">{{asRepair.repairAsAgentNm  }}</td>
            <td>처리기사</td>
            <td colspan="2">{{asRepair.repairNm  }}</td>
          </tr>
          <tr style="background-color: white;">
            <td height="20">기술료</td>
            <td>{{asRepair.asRepairAmt  }}</td>
            <td>자재비</td>
            <td>{{asRepair.asRepairItemAmt  }}</td>
            <td>실청구금액</td>
            <td>{{asRepair.asRepairFeeAmtReal  }}</td>
          </tr>
          <tr style="background-color: white;">
            <td height="10" colspan="6"></td>
          </tr>
          <tr style="background-color: white;">
            <td style="height: 20px; font-size: 14px;">자재사용내역</td>
            <td colspan="5">
              <table>
                <tr style="background-color: #FFFFFF; ">
                  <td style="width: 9%; text-align: center;">순번</td>
                  <td style="width: 16%; text-align: center;">품번</td>
                  <td style="width: 18%; text-align: center;">품명</td>
                  <td style="width: 18%; text-align: center;">규격</td>
                  <td style="width: 8%; text-align: center;">수량</td>
                  <td style="width: 16%; text-align: center;">단가</td>
                  <td style="width: 15%; text-align: center;">금액</td>
                </tr>
              </table>
              <table v-if = "asItem.length == 0" >
                <tr bgcolor="#FFFFFF" v-for="i in 3">
                  <td style="width: 9%; height: 20px; overflow:hidden; text-align: center;"><nobr>{{i}}</nobr></td>
                  <td style="width: 16%; height: 20px; overflow:hidden; text-align: center;"><nobr></nobr></td>
                  <td style="width: 18%; overflow:hidden; text-align: center;"><nobr></nobr></td>
                  <td style="width: 18%; overflow:hidden; text-align: center;"><nobr></nobr></td>
                  <td style="width: 8%; overflow:hidden; text-align: center;"><nobr></nobr></td>
                  <td style="width: 16%; overflow:hidden; text-align: center;"><nobr></nobr></td>
                  <td style="width: 15%; overflow:hidden; text-align: center;"><nobr></nobr></td>
                </tr>
              </table>
              <table v-else >
                <tr bgcolor="#FFFFFF" v-for="(item, i) in asItem" :key="i">
                  <td style="width: 9%; height: 20px; overflow:hidden; text-align: center;"><nobr>{{item.asProcessId}}</nobr></td>
                  <td style="width: 16%; height: 20px; overflow:hidden; text-align: center;"><nobr>{{item.itemCd}}</nobr></td>
                  <td style="width: 18%; overflow:hidden; text-align: center;"><nobr>{{item.itemNm}}</nobr></td>
                  <td style="width: 18%; overflow:hidden; text-align: center;"><nobr>{{item.itemSpec}}</nobr></td>
                  <td style="width: 8%; overflow:hidden; text-align: center;"><nobr>{{item.itemQty}}</nobr></td>
                  <td style="width: 16%; overflow:hidden; text-align: center;"><nobr>{{item.unitPrice1}}</nobr></td><!--단가-->
                  <td style="width: 15%; overflow:hidden; text-align: center;"><nobr>{{item.unitPrice3}}</nobr></td><!--금액-->
                </tr>
              </table>
            </td>
          </tr>
          <tr bgcolor="white">
            <td height="40">특이사항</td>
            <td colspan="5" class="font12_red">&nbsp;{{ asRepair.asDescription }}</td>
          </tr>
        </table>
      </td>
    </tr>
    <tr>
      <td>&nbsp;</td>
    </tr>
    <tr>
      <td>
        <table width="100%" border="0" cellspacing="0" cellpadding="0">
          <tr>
            <td width="47%">&nbsp;</td>
            <td width="23%" class="font-big">상기내용을 확인합니다. </td>
            <td width="30%">
              <table width="100%" border="1" cellpadding="0" cellspacing="0" bordercolor="#000000" class="font-big">
                <tr>
                  <td height="37">
                    &nbsp;<br />
                    처리기사 확인 :
                    <br />&nbsp;
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </td>
    </tr>
    <tr height="150"></tr>
  </table>
</template>
<script>
export default {
  name : 'RepairScreen',
  props: {
    asRepair: {
      Type: Object,
      default: {
        asId: ''
      }
    },
    idx: {
      Type: Number,
    },
    asItem: {
      Type: Array,
    },

  },
  data() {
    return {
    };
  },
}
</script>
